import * as React from 'react';
import Styled from 'styled-components';

import { BreakPointsMap, media } from '../../../lib/StyledComponents';
import SVGIcon from '../../Icon/SVGIcon';
import {
  ISubNavLinkOptions,
  SubNavButton,
  SubNavButtonContain,
  SubNavSpan
} from '../Common/SubNavLink';

export {
  ISubNavLinkOptions
} from '../Common/SubNavLink';

const CollapsibleSubNavButtonContain = Styled(SubNavButtonContain)`
  ${media.small`
    flex: 0;
    padding-right: 1em;

    &:last-child {
      padding-right: 0;
    }
  `}

  ${media.ie11`
    flex: 1;
  `}

  ${media.build({ minWidth: BreakPointsMap.small, ie11: true })`
    flex: 0 0 auto;
  `}
`;

const CollapsibleSubNavButton = Styled(SubNavButton)`
  ${media.small`
    justify-content: normal;
    width: unset;
  `}
`;

export interface ICollapsibleSubNavLinkProps
  extends ISubNavLinkOptions,
    React.ButtonHTMLAttributes<HTMLButtonElement> {}

export class CollapsibleSubNavLink extends React.PureComponent<ICollapsibleSubNavLinkProps> {
  public render () {
    const { icon, theme, name, ...rest } = this.props;

    return (
      <CollapsibleSubNavButtonContain>
        <CollapsibleSubNavButton {...rest}>
          <SVGIcon icon={icon} iconStyle={theme} />
          <SubNavSpan>{name}</SubNavSpan>
        </CollapsibleSubNavButton>
      </CollapsibleSubNavButtonContain>
    );
  }
}
